import { produce } from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.ISocketState = {
    connection: undefined,
    connected: false,
    isError: false
};

export const reducer = produce((draftState, action: Types.ISocketAction): Types.ISocketState | void => {
    switch (action.type) {
        case actionTypes.SET_CONNECTION: {
            draftState.connection = action.payload;

            break;
        }

        case actionTypes.SET_CONNECTED: {
            draftState.connected = action.payload;

            break;
        }

        case actionTypes.UNSET_CONNECTION: {
            draftState.connection = undefined;

            break;
        }

        case actionTypes.TOGGLE_CONNECTION_ERROR: {
            draftState.isError = action.payload;

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
